import { value } from "../../../helpers";

export const getMultipleAutocompleteValues = (valores, lista, chaveId) => {
  if (valores) {
    return valores.map((item) => value.autoComplete(lista, item[chaveId]));
  }
  return [];
};
